import { render, staticRenderFns } from "./IconDak.vue?vue&type=template&id=3e9f218a"
import script from "./IconDak.vue?vue&type=script&lang=ts"
export * from "./IconDak.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports